<template>
  <div>
    <router-view></router-view>
    <GA4Modal v-if="showGa4Modal"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import JwtDecode from 'jwt-decode'
import Vue from 'vue'
import AirbrakeClient from 'airbrake-js'
import Axios from "axios";
import GA4Modal from './views/modals/GA4Modal.vue'

export default {
  name: 'app',
  components: { GA4Modal: GA4Modal },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      currentClient: 'currentClient',
      redirectPath: 'redirectPath'

    })
  },
  data: function () {
    return {
      ssoLoginCheck: false,
      domain: null,
      showGa4Modal: false
    }
  },

  mounted() {
    this.checkUser()
    setInterval(this.checkAppVersion, 300000)
  },

  updated () {
    this.checkUser()
  },

  beforeCreate () {
    const ssoToken = this.$cookies.get('sso_token')
    if (!localStorage.token && ssoToken){
      (async () => {
        let response = await Axios.post('/sso_token_login', {sso_token: ssoToken})
        this.loginSuccessful(response)
      })()
    }
  },

  created () {
    this.checkDomain()
    this.$store.commit('redirectToPath', window.location.pathname)
    if (process.env.NODE_ENV === 'production'){
      this.setupAirbrake()
    }
    if (localStorage.token && window.location.pathname === '/') {
      var obj = JwtDecode(localStorage.token)
      var dashboardId = parseInt(obj.default_dashboard_id, 10)
      if (dashboardId){
        if (this.domain) {
          this.$router.push(`/dashboards/${dashboardId}?domain=${this.domain}`)
        } else {
          this.$router.push('/dashboards/' + dashboardId)
        }
      }
    }
    this.$eventBus.$on('showGa4Modal', (val) => { this.showGa4Modal = val })
  },

  methods: {

    checkUser () {
      if (!localStorage.token && !(window.location.pathname == '/login')) {
        if (this.domain) {
          this.$router.push(`/login?domain=${this.domain}`)
        } else {
          this.$router.push({ path: 'login', query: this.$router.query})
        }
      }
    },
    checkDomain () {
      let uri = window.location.search.substring(1)
      let params = new URLSearchParams(uri)
      this.domain = params.get("domain")
    },

    loginSuccessful (response) {
      var token = response.data.jwt
      if (!token) {
        return false
      }
      localStorage.token = token
      this.$store.commit('login')
      this.$http.defaults.headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
      var obj = JwtDecode(token)
      var dashboardId = parseInt(obj.default_dashboard_id, 10)
      if (dashboardId){
        this.checkRedirect('/dashboards/' + dashboardId)
      } else {
        this.checkRedirect()
      }
    },

    checkRedirect (redirect_url=null) {
      if (this.domain) {
        if (redirect_url) {
          this.$router.push(`${redirect_url}?domain=${this.domain}`)
        } else if (this.redirectPath) {
          this.$router.push(`/?domain=${this.domain}`)
          this.$router.push(`${this.redirectPath}?domain=${this.domain}`)
        } else {
          this.$router.push(`/?domain=${this.domain}`)
        }
      } else {
        if (redirect_url) {
          this.$router.push(redirect_url)
        } else if (this.redirectPath) {
          this.$router.push('/')
          this.$router.push(this.redirectPath)
        } else {
          this.$router.push('/')
        }
      }
    },

    checkAppVersion () {
      this.$http.get('/app_version')
        .then(function(response){
          if (response.status == 200 && response.data.version != '1.0.6'){
            window.location.reload(true)
          }
        }.bind(this))
    },

    setupAirbrake () {
      var airbrake = new AirbrakeClient({
        projectId: 224619,
        projectKey: '645f195079847a2b1b7ee6c291614701'
      })

      Vue.config.errorHandler = function(err, vm, info) {
        airbrake.notify({
          error: err,
          params: {info: info}
        })
      }
    }

  }

}
</script>

<style lang="scss">
  // CoreUI Icons Set
  @import '~@coreui/icons/css/coreui-icons.min.css';
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';
  /* Import Flag Icons Set */
  @import '~flag-icon-css/css/flag-icon.min.css';
  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
